export default{
    lista:{
        method:'get',
        url:'folhar/calendario/lista'
    },
    listatrabalhador:{
        method:'get',
        url:'trabalhador/pesquisa{/id}'
    },
    listatomador:{
        method:'get',
        url:'tomador/pesquisa{/id}'
    },
    cadastra:{
        method:'post',
        url:'folhar/calendario/cadastro'
    },
    delete:{
        method:'delete',
        url:'folhar/calendario/deletar{/id}'
    },
    editar:{
        method:'get',
        url:'comissionado/editar{/id}'
    },
    update:{
        method:'post',
        url:'comissionado/update'
    }
}